export default "__VITE_ASSET__CDE$BAah__"